import moment from 'moment';
import { MxBaseMask } from './mx-mask-base';

export class MxIntervalMask extends MxBaseMask {
	constructor() {
		super();
		this.minutesSep = ':';
		this.hoursSep = ':';
		this.daysSep = '.';
		this.parseAttributes = ['mxMaskFormat'];
	}
	createFormatter(ngModel) {
		return function (value) {
			const actualValue =
				this.durationType === 'fulltime'
					? value
							.toString()
							.replace('h' + this.hoursSep, this.hoursSep)
							.replace('m' + this.minutesSep, this.minutesSep)
							.replace('s', '')
					: value
							.toString()
							.replace('h' + this.hoursSep, this.hoursSep)
							.replace('m', '');

			const isReadonly = !ngModel.$$lastCommittedViewValue || ngModel.$$updateEvents === 'blur';
			return this.applyFormat(actualValue, isReadonly) || value;
		};
	}

	createParser() {
		return function (value) {
			return this.getMinutes(value);
		};
	}

	initialize(options) {
		var maxSymbols = 4,
			availableSep = '',
			pattern = 0 + this.repeat('9', maxSymbols - 1);

		this.format = this.format || 'mmm';

		//initialize by durationType
		if (this.format === 'hh:mm:ss') {
			this.durationType = 'fulltime';
			availableSep += this.minutesSep;
			pattern += this.hoursSep + '00' + this.minutesSep + '00';
		} else if (this.format && this.format.indexOf('d') !== -1) {
			this.durationType = 'days';
			availableSep += this.daysSep + this.hoursSep;
			pattern += this.daysSep + '00' + this.hoursSep + '00';
		} else if (this.format && this.format.indexOf('h') !== -1) {
			this.durationType = 'hours';
			availableSep += this.hoursSep;
			pattern += this.hoursSep + '00';
		} else {
			this.durationType = 'minutes';
		}

		this.clearRegex = new RegExp('[^0-9' + availableSep + ']', 'g');
		Object.assign(options, { reverse: false });
		delete options.onChange;
		this.viewMask = this.createMask(pattern, options);
	}

	blur(ngModel) {
		if (ngModel.$viewValue) {
			ngModel.$setViewValue(this.applyFormat(ngModel.$viewValue.toString(), true) || ngModel.$viewValue.toString());
			ngModel.$render();
		}
	}

	focus(ngModel) {
		if (ngModel.$viewValue) {
			ngModel.$setViewValue(this.applyFormat(ngModel.$viewValue.toString(), false) || ngModel.$viewValue.toString());
			ngModel.$render();
		}
	}

	applyFormat(value, isReadonly) {
		if (value && value.replace(this.clearRegex, '')) {
			if (isReadonly) {
				var result = this.formatDuration(this.getMinutes(value));
				result = result.replace(this.clearRegex, '');

				return this.durationType === 'fulltime'
					? result.replace(/:([0-9]+):([0-9]+)$/, 'h' + this.hoursSep + '$1m' + this.minutesSep + '$2s')
					: result.replace(this.hoursSep, 'h' + this.hoursSep) + 'm';
			}

			if (value.toString().indexOf(this.hoursSep) === -1) {
				// in minutes
				value = this.formatDuration(this.getMinutes(value));
			}

			return this.durationType === 'fulltime'
				? value
						.replace('h' + this.hoursSep, this.hoursSep)
						.replace('m' + this.minutesSep, this.minutesSep)
						.replace('s', '')
				: value.replace('h' + this.hoursSep, this.hoursSep).replace('m', '');
		}

		return null;
	}

	formatDuration(value) {
		var result =
			this.durationType === 'fulltime'
				? parseFloat(value) + 0.001 /* to avoid seconds flooring to prev second on big values (e.g. 4331.583333333333 is 35 sec, but not 34 sec) */
				: parseInt(value);

		if (this.durationType !== 'minutes') {
			var duration = moment.duration(result, 'minutes');

			if (this.durationType === 'hours') {
				result = Math.floor(result / 60) + this.hoursSep + duration.minutes();
			} else if (this.durationType === 'days') {
				result = Math.floor(result / (24 * 60)) + this.daysSep + duration.hours() + this.hoursSep + duration.minutes();
			} else if (this.durationType === 'fulltime') {
				result =
					Math.floor(result / 60) +
					this.hoursSep +
					(duration.minutes() < 10 ? '0' : '') +
					duration.minutes() +
					this.minutesSep +
					(duration.seconds() < 10 ? '0' : '') +
					duration.seconds();
			}
		}

		return result + ''; // to string
	}

	getMinutes(value) {
		// Possible cases: "72:00:03", "72h:00m:03s", "4320.1823452345325"(string)
		if (this.durationType === 'fulltime') {
			return $.isNumeric(value)
				? parseFloat(value)
				: moment
						.duration(
							value
								.replace('h' + this.hoursSep, this.hoursSep)
								.replace('m' + this.minutesSep, this.minutesSep)
								.replace('s', ''),
							'seconds'
						)
						.asMinutes();
		}

		// Possible cases: "0:5", 5, "5", "0h:5m", "5m"
		if ($.isNumeric(value) && value.indexOf(this.hoursSep) === -1) {
			return parseInt(value);
		}

		// if value starts with digits and ends on not digit (like '4:', '4h', ar any other) then on UI it always shows like '4:', so lets format it like 4:00 means 4 hours
		if (this.durationType === 'hours' && /^\d+[^\d]$/.test(value)) {
			value = value.substr(0, value.length - 1) + this.hoursSep + '00';
		} else if ((this.durationType === 'days' || this.durationType === 'hours') && value.indexOf(this.hoursSep) === -1) {
			value += this.hoursSep + '00';
		}

		var valueForParsing = value.indexOf('h') > -1 ? value.replace('h' + this.hoursSep, this.hoursSep).replace('m', '') : value.replace('m', '');
		valueForParsing = valueForParsing === parseInt(valueForParsing) + '' ? parseInt(valueForParsing) : valueForParsing;

		return moment.duration(valueForParsing, 'minutes').asMinutes();
	}
}
